"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/dropdown/style/css");

var _dropdown = _interopRequireDefault(require("antd/es/dropdown"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/menu/style/css");

var _menu = _interopRequireDefault(require("antd/es/menu"));

require("antd/es/tabs/style/css");

var _tabs = _interopRequireDefault(require("antd/es/tabs"));

var _lodash = require("lodash");

var _icons = require("@ant-design/icons");

var _steps = _interopRequireDefault(require("antd/lib/steps"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _BadgesTable = _interopRequireDefault(require("../../../../components/badge/BadgesTable"));

var _CommentsTable = _interopRequireDefault(require("../../../../components/forum/CommentsTable"));

var _PostsTable = _interopRequireDefault(require("../../../../components/forum/PostsTable"));

var _IncentivesTable = _interopRequireDefault(require("../../../../components/incentives/IncentivesTable"));

var _NotificationLogTable = _interopRequireDefault(require("../../../../components/notification/NotificationLogTable"));

var _UserSurveyTable = _interopRequireDefault(require("../../../../components/survey/UserSurveyTable"));

var _TestkitTable = _interopRequireDefault(require("../../../../components/testkit/TestkitTable"));

var _participants = require("../../../../redux/participants/participants.types");

var selectors = _interopRequireWildcard(require("../../../../redux/selectors"));

require("./participant.scss");

var _ParticipantEditCard = _interopRequireDefault(require("./ParticipantEditCard"));

var _ParticipantViewCard = _interopRequireDefault(require("./ParticipantViewCard"));

var _ThreadsTable = _interopRequireDefault(require("../../../../components/forum/ThreadsTable"));

var _FormTable = _interopRequireDefault(require("../../../../components/form/FormTable"));

var _ParticipantDemographicsCard = _interopRequireDefault(require("./ParticipantDemographicsCard"));

var _ParticipantNoteCard = _interopRequireDefault(require("./ParticipantNoteCard"));

var _notes = require("../../../../redux/notes/notes.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Tab = _tabs.default;
const {
  Step
} = _steps.default;
const footerActionStyle = {
  textAlign: 'right',
  width: '50%'
};
const initialState = {
  inEditMode: false,
  editedParticipant: {},
  selectedKey: 'posts',
  activeForm: ''
};

class Participant extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.handleEditClick = () => {
      const {
        participant
      } = this.props;

      if (participant) {
        this.setState({
          inEditMode: true,
          editedParticipant: participant
        });
      }
    };

    this.handleSaveClick = participant => {
      const {
        saveParticipant
      } = this.props;
      saveParticipant(participant);
      console.log(participant);
      this.setState({
        inEditMode: false
      });
    };

    this.handleSaveNoteClick = note => {
      const {
        saveParticipantNote
      } = this.props;
      saveParticipantNote(note);
    };

    this.handleCancelClick = () => {
      this.setState({
        inEditMode: false
      });
    };

    this.closeForm = () => {
      this.setState({
        activeForm: ''
      });
    };

    this.formOptions = /*#__PURE__*/_react.default.createElement(_menu.default, {
      onClick: this.handleMenuClick.bind(this)
    }, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "ADVERSE_EVENT"
    }, "Adverse Event"), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "EARLY_TERMINATION"
    }, "Early Termination"), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "PROTOCOL_DEVIATION"
    }, "Protocol Deviation"), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "SOCIAL_HARM"
    }, "Social Harm"));

    this.renderFormModal = type => {
      switch (type) {
        default:
          return /*#__PURE__*/_react.default.createElement("div", null);
      }
    };
  }

  componentDidMount() {
    const {
      loadParticipant
    } = this.props;
    loadParticipant();
  }

  handleMenuClick(e) {
    this.setState({
      activeForm: e.key
    });
  }

  render() {
    const {
      avatar,
      loadParticipantStatus,
      studyArm,
      participant,
      posts,
      notes,
      threads,
      forms,
      notifications,
      testkits,
      comments,
      userSurveys,
      incentives,
      participantBadges,
      showSurveys,
      showIncentives,
      showForms,
      showTestKits
    } = this.props;
    const participantSubpage = this.props.participantSubpage === '' ? 'Timeline' : this.props.participantSubpage;
    const {
      editedParticipant,
      activeForm
    } = this.state;

    if (loadParticipantStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Loading Participant");
    }

    if (loadParticipantStatus.isError) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error loading the requested participant.");
    }

    if (studyArm === undefined) {
      return /*#__PURE__*/_react.default.createElement("div", null, "The participant is assigned to an invalid study arm or you do not have permissions to view the study.");
    }

    if (participant === undefined) {
      return /*#__PURE__*/_react.default.createElement("div", null, "The participant does not exist or you do not have permissions to view the participant.");
    }

    const avatarBase64 = avatar ? avatar.avatar : undefined;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "participant"
    }, /*#__PURE__*/_react.default.createElement(_steps.default, {
      type: "navigation",
      size: "small",
      current: 1
    }, /*#__PURE__*/_react.default.createElement(Step, {
      title: "Accepted"
    }), /*#__PURE__*/_react.default.createElement(Step, {
      title: `${_lodash._.capitalize(participant.status)}`
    }), /*#__PURE__*/_react.default.createElement(Step, {
      title: "Finished"
    })), /*#__PURE__*/_react.default.createElement(_ParticipantViewCard.default, {
      avatarBase64: avatarBase64,
      participant: participant
    }), /*#__PURE__*/_react.default.createElement(_ParticipantNoteCard.default, {
      participant: participant,
      notes: notes,
      saveClickHandler: this.handleSaveNoteClick
    }), this.renderFormModal(activeForm), /*#__PURE__*/_react.default.createElement("div", {
      id: "tab-bar"
    }, /*#__PURE__*/_react.default.createElement(Tab, {
      defaultActiveKey: participantSubpage
    }, /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Demographics",
      key: "2"
    }, /*#__PURE__*/_react.default.createElement("div", null, this.state.inEditMode ? /*#__PURE__*/_react.default.createElement(_ParticipantEditCard.default, {
      studyArm: studyArm,
      initialParticipant: participant,
      saveClickHandler: this.handleSaveClick,
      cancelClickHandler: this.handleCancelClick
    }) : /*#__PURE__*/_react.default.createElement(_ParticipantDemographicsCard.default, {
      studyArm: studyArm,
      participant: participant,
      editClickHandler: this.handleEditClick
    }))), showSurveys && /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "User Surveys",
      key: "userSurveys"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_UserSurveyTable.default, {
      userSurveys: userSurveys
    }))), /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Posts",
      key: "forum"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_PostsTable.default, {
      posts: posts
    }))), /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Comments",
      key: "comments"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CommentsTable.default, {
      comments: comments
    }))), /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Message Threads",
      key: "4"
    }, /*#__PURE__*/_react.default.createElement(_card.default, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ThreadsTable.default, {
      threads: threads
    })))), showForms && /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Forms",
      key: "5"
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      style: {
        background: 'white'
      },
      title: /*#__PURE__*/_react.default.createElement(_dropdown.default, {
        style: footerActionStyle,
        overlay: this.formOptions
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "default"
      }, "New Form", ' ', /*#__PURE__*/_react.default.createElement(_icons.DownOutlined, null)))
    }, /*#__PURE__*/_react.default.createElement(_FormTable.default, {
      forms: forms
    }))), /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Notifications",
      key: "6"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_NotificationLogTable.default, {
      participantNotifications: notifications
    }))), showTestKits && /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Test Kits",
      key: "7"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_TestkitTable.default, {
      participantTestkits: testkits
    }))), showIncentives && /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Incentives",
      key: "8"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IncentivesTable.default, {
      participantId: participant.id,
      participantIncentives: incentives
    }))), /*#__PURE__*/_react.default.createElement(Tab.TabPane, {
      tab: "Badges",
      key: "9"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_BadgesTable.default, {
      participantBadges: participantBadges
    }))))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  avatar: selectors.getRequestedStudyParticipantAvatar,
  loadParticipantStatus: selectors.loadRequestedParticipantStatus,
  studyArm: selectors.getRequestedStudyParticipantStudyArm,
  participant: selectors.getRequestedStudyParticipant,
  notes: selectors.getRequestedStudyParticipantNotes,
  posts: selectors.getRequestedStudyParticipantPosts,
  comments: selectors.getRequestedStudyParticipantComments,
  threads: selectors.getRequestedStudyParticipantThreads,
  forms: selectors.getRequestedParticipantForms,
  notifications: selectors.getRequestedParticipantNotifications,
  testkits: selectors.getRequestedParticipantTestkits,
  participantSubpage: selectors.getRequestedParticipantTab,
  userSurveys: selectors.getRequestedParticipantUserSurveys,
  incentives: selectors.getRequestedParticipantIncentives,
  participantBadges: selectors.getRequestedStudyParticipantBadges,
  showSurveys: selectors.getSurveysFeatureEnabled,
  showIncentives: selectors.getIncentivesFeatureEnabled,
  showTestKits: selectors.getTestKitsFeatureEnabled,
  showForms: selectors.getFormsFeatureEnabled
});

const mapDispatchToProps = dispatch => {
  return {
    loadParticipant: () => dispatch(_participants.loadRequestedParticipantAsync.request()),
    saveParticipant: participant => dispatch(_participants.saveParticipantAsync.request(participant)),
    saveParticipantNote: note => dispatch(_notes.saveParticipantNoteAsync.request(note))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Participant);

exports.default = _default;